<template>
    <p class="message"><slot></slot></p>
</template>

<script>
export default {
    name: "qw-text-message"
}
</script>

<style lang="scss" scoped>
.message {
    margin: 0;
    padding: 7px 15px;
    font-family: $lato;
    font-weight: normal;
    font-size: 14px;
    border-radius: 15px 3px 15px 15px;
    color: $white;
    background-color: $primary;
}
.reply {
    align-items: flex-start;
    .sender {
        text-align: left;
    }
    .message {
        background-color: $green;
        border-radius: 3px 15px 15px 15px;
    }
}
.dark {
    .message {
        background-color: $dark-purple;
    }
    .reply {
        .message {
            background-color: $teal;
        }
    }
}
</style>